"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = OnChangeProvider;
exports.OnChangeContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var OnChangeContext = /*#__PURE__*/_react["default"].createContext(null);

exports.OnChangeContext = OnChangeContext;
var propTypes = {
  children: _propTypes["default"].node.isRequired,
  onChange: _propTypes["default"].func.isRequired
};

function OnChangeProvider(props) {
  var children = props.children,
      onChange = props.onChange;
  return /*#__PURE__*/_react["default"].createElement(OnChangeContext.Provider, {
    value: onChange
  }, children);
}

OnChangeProvider.propTypes = propTypes;
//# sourceMappingURL=OnChangeProvider.js.map